import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';

var getContentWidth = function (isFullWidth) {
  if (isFullWidth === void 0) {
    isFullWidth = false;
  }
  if (isFullWidth) return "none";
  return ["none", 708, 1160];
};
var Content = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Section__Content",
  componentId: "sc-al2hsn-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: content-box;\n"], ["\n  box-sizing: content-box;\n"])));
var Section = forwardRef(function (_a, ref) {
  var isFullWidth = _a.isFullWidth,
    children = _a.children,
    id = _a.id,
    rest = __rest(_a, ["isFullWidth", "children", "id"]);
  return React__default.createElement(Box, __assign({
    id: id,
    ref: ref
  }, rest), React__default.createElement(Content, {
    px: ["20px", "35px"],
    mx: "auto",
    maxWidth: getContentWidth(isFullWidth)
  }, children));
});
Section.defaultProps = {
  isFullWidth: false
};
Section.displayName = "Section";
var templateObject_1;

export { Section };
//# sourceMappingURL=Section.js.map
